/* Titanium Pan prelander. Loaded by several sections; runs once. */
(function () {
  if (window.__mfp) return;
  window.__mfp = true;

  function init() {
    // Carry the landing URL's marketing parameters (utm_*, fbclid, gclid, ttclid, ad ids...) onto every CTA,
    // so attribution survives the click to the product page. Keys starting with "_" are Shopify-internal
    // search params and are left behind. Parameters already on a link are never overwritten.
    var landing = new URLSearchParams(window.location.search);
    document.querySelectorAll('a[data-mfp-cta]').forEach(function (a) {
      try {
        var url = new URL(a.getAttribute('href'), window.location.origin);
        landing.forEach(function (value, key) {
          if (key.charAt(0) !== '_' && !url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        a.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {}
    });

    // Mobile sticky CTA: visible after the hero, hidden while an offer block is on screen.
    var sticky = document.querySelector('.mfp-sticky');
    var hero = document.querySelector('.mfp-hero');
    if (!sticky || !hero || !('IntersectionObserver' in window)) return;
    var pastHero = false, offersVisible = 0;
    function sync() { sticky.classList.toggle('is-on', pastHero && offersVisible === 0); }
    new IntersectionObserver(function (e) {
      pastHero = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      sync();
    }).observe(hero);
    var offerIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { offersVisible += e.isIntersecting ? 1 : (e.target.__seen ? -1 : 0); e.target.__seen = e.isIntersecting; });
      offersVisible = Math.max(0, offersVisible);
      sync();
    });
    document.querySelectorAll('.mfp-offer').forEach(function (el) { offerIo.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
